import Konva from 'konva';

class ConfiguratorRollingGate{

	constructor(settings) {
		this.hasDifferentHeights = false;
		this.settings = settings;
		this.tarpMaxSize = 550;
		this.imagesUrl = '../app/themes/kampa/dist/images/configurator/';
		this.scale = 1;
		this.minOffsetFromSide = 100;
		this.windingTubeHeight = 79;
		this.errors = [];

		this.mobileLastCenter = null;
		this.mobileLastDist = 0;
	}

	init(cont){
		var positionInfo = cont.getBoundingClientRect();
		this.canvasHeight = positionInfo.height;
		this.canvasWidth = positionInfo.width;
		let self = this;

		this.tarpMaxSize = 0.8 * Math.min(this.canvasWidth,this.canvasHeight);

		this.stage = new Konva.Stage({
			container: 'configurator-container',
			width: this.canvasWidth,
			height: this.canvasHeight,
			draggable: true,
		});

		// Layers
		this.tarpLayer = new Konva.Layer();
		this.dimensionsLayer = new Konva.Layer();

		// Winding Tube
		this.windingTubeGroup = new Konva.Group({
			y: -this.windingTubeHeight,
			x: 0,
		});

		this.windingTubeHoldersGroup = new Konva.Group({
			y: 0,
			x: 0,
		});
		this.tubePipeInnerRect = new Konva.Rect({
			x: 0,
			y: 2,
			width: 200,
			height: this.windingTubeHeight-4,
			fill: '#0e0e0e',
		});
		this.tubePipeRect = new Konva.Rect({
			x: 0,
			y: 1,
			width: 200,
			height: this.windingTubeHeight-2,
			fill: '#ccc',
		});
		this.tubeRect = new Konva.Rect({
			x: 0,
			y: 0,
			width: 200,
			height: this.windingTubeHeight,
			fill: '#ccc',
			shadowOffset: { x: 0, y: 0 },
			shadowOpacity: 0.2,
		});
		this.tubeHelperRect = new Konva.Rect({
			x: 0,
			y: 0,
			width: 200,
			height: this.windingTubeHeight,
			fill: 'transparent',
		});

		this.windingTubeGroup.add(this.tubeHelperRect);
		this.windingTubeGroup.add(this.windingTubeHoldersGroup);
		this.windingTubeGroup.add(this.tubePipeInnerRect);
		this.windingTubeGroup.add(this.tubePipeRect);
		this.windingTubeGroup.add(this.tubeRect);

		// Pipe
		this.pipeGroup = new Konva.Group({
			x: 0,
			y: 0,
			width: 10,
			height: 35,
		});

		// Tarp
		this.tarp = new Konva.Line({
			points: [0,0,200,0,200,200,0,200],
			fill: '#00D2FF',
			strokeWidth: 0,
			closed: true,
			//shadowColor: 'black',
			//shadowBlur: 10,
			shadowOffset: { x: 0, y: 0 },
			shadowOpacity: 0.2,
		});

		this.tarpLayer.add(this.tarp);
		this.tarpLayer.add(this.windingTubeGroup);
		this.tarpLayer.add(this.pipeGroup);

		//inner crop group
		this.innerCropGroup = new Konva.Group({
			clipFunc: function(ctx){
				var polygon = self.tarp.points();
				ctx.beginPath();
				ctx.moveTo(polygon[0], polygon[1]);
				for(var item = 2; item < polygon.length-1; item += 2 ){
					ctx.lineTo( polygon[item] , polygon[item+1] )
				}
				ctx.closePath();
			},
		});
		this.tarpLayer.add(this.innerCropGroup);

		// Mounting type
		this.mountingType = 'none';
		this.mountingTypeGroup = new Konva.Group({
			x: 0,
			y: 0,
		});
		this.railGroupLeft = new Konva.Group();
		this.railGroupRight = new Konva.Group();

		this.tarpLayer.add(this.mountingTypeGroup);
		this.tarpLayer.add(this.railGroupLeft);
		this.tarpLayer.add(this.railGroupRight);

		// Windows
		this.windowsData = {};
		this.windows = new Konva.Group();
		this.tarpLayer.add(this.windows);

		/**
		 * Dirt lap
		 */
		this.hasDirtLap = false;
		this.dirtLap = new Konva.Group();

		/**
		 * Hit boxes
		 */
		this.hitBoxesGroup = new Konva.Group({
			x: 0,
			y: 0,
		});

		/**
		 * Dimensions
		 */
		this.tarpDimensions = new Konva.Group();
		this.dimensionsLayer.add(this.tarpDimensions);
		this.slant = 'top';

		// add the layer to the stage
		this.stage.add(this.tarpLayer);
		this.stage.add(this.dimensionsLayer);

		this.allowStageZoom();
	}

	setTarpSize(width, heightLeft, heightRight, slant){
		this.tarpWidth = width;
		this.tarpHeightLeft = heightLeft;
		this.tarpHeightRight = heightRight;
		this.slant = slant;

		let height = Math.max(heightLeft,heightRight);
		this.tarpHeight = height;

		this.scale = this.tarpMaxSize / Math.max(width,height);

		if(this.slant == 'top'){
			this.tarp.points([0,height-heightLeft, width,height-heightRight, width,height, 0,height]);
		} else {
			this.tarp.points([0,0, width,0, width,heightRight, 0,heightLeft]);
		}

		this.tarp.shadowBlur(10/this.scale);
		this.tarpLayer.x((this.canvasWidth - width * this.scale) / 2);
		this.tarpLayer.y((this.canvasHeight - height * this.scale) / 2);
		this.tarpLayer.scale({ x: this.scale, y: this.scale});

		this.updateWindingTube();
		this.setMountingType(this.mountingType);
		this.updatePipe();
		this.updateHitBoxes();
		this.updateTarpDimensions();
		this.updateWindows();
		this.updateDirtLap();
	}

	setTarpColor(color){
		this.tarp.fill(color);
		this.setWindingTubeColor(color);
		this.updateDirtLap();
	}

	setMountingType(type){
		this.mountingType = type;
		this.mountingTypeGroup.destroyChildren();
		let height = this.tarpHeight;
		let width = this.tarpWidth;
		let element = (type == 'guide') ? this.getExtrasElement('rolling_gate_slider') : this.getExtrasElement(type);

		if(element){
			let offsetFromTop = 400;
			let offsetFromBottom = 200;
			let elementsGap = 400;
			let sideLength = height - element.height - offsetFromTop - offsetFromBottom;
			let elementsCount = Math.ceil(sideLength / elementsGap);

			let groupLeft = new Konva.Group({
				x: element.offsetFromSide,
				y: offsetFromTop,
			});
			let groupRight = new Konva.Group({
				x: width - element.offsetFromSide,
				y: offsetFromTop,
				scaleX: -1,
			});

			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				for(var i = 0; i < elementsCount + 1; i++){
					var node = new Konva.Image({
						width: element.width,
						height: element.height,
						image: imageObj,
						zIndex: 2,
					});

					node.y( i * sideLength / elementsCount );

					groupLeft.add(node);
					groupRight.add(node.clone());
				}
			};
			imageObj.src = this.settings.images[element.image];

			this.mountingTypeGroup.add(groupLeft);
			this.mountingTypeGroup.add(groupRight);
		}


		this.updateRails();
		this.updatePipe();
		this.updateWindingTube();
		this.updateTarpDimensions();
	}

	setControl(control, side = 'left'){
		this.control = control;
		this.controlSide = side;
		this.updateWindingTube();
	}

	updateWindingTube(){
		let self = this;
		let pipeWidth = (this.mountingType == 'guide') ? this.tarpWidth + 90 : this.tarpWidth + 10;
		let pipeX = (this.tarpWidth - pipeWidth) / 2;
		let pipeInnerX = pipeX - 2;
		let pipeInnerWidth = pipeWidth + 4;
		var engineWidth = 33;
		var engineHeight = this.windingTubeHeight-12;
		var totalWidth = pipeInnerWidth;
		var totalX = pipeInnerX;

		this.tubePipeRect.width(pipeWidth);
		this.tubePipeRect.x(pipeX);

		this.tubePipeInnerRect.width(pipeInnerWidth);
		this.tubePipeInnerRect.x(pipeInnerX);

		this.tubeRect.shadowBlur(10/this.scale);
		this.tubeRect.width(this.tarpWidth);
		this.setWindingTubeColor(this.tarp.fill());

		this.windingTubeHoldersGroup.destroyChildren();
		this.windingTubeHoldersGroup.x(pipeInnerX);

		let crankElement = this.getExtrasElement('crank');
		let holderElement = this.getExtrasElement('tube_holder');

		if(this.control == 'crank'){
			let crankImageObj = new Image();
			crankImageObj.crossOrigin = 'anonymous';
			crankImageObj.onload = function () {
				var node = new Konva.Image({
					width: crankElement.width,
					height: crankElement.height,
					image: crankImageObj,
					x: (self.controlSide == 'right') ? pipeInnerWidth : -crankElement.width,
					y: 16,
				});

				self.windingTubeHoldersGroup.add(node);
			};
			crankImageObj.src = this.settings.images[crankElement.image];

			totalWidth += crankElement.width;
		}
		else{

			let engineRect = new Konva.Rect({
				width: engineWidth,
				height: engineHeight,
				x: (self.controlSide == 'right') ? pipeInnerWidth : -engineWidth,
				fill: '#3a3a3a',
				y: (self.windingTubeHeight - engineHeight) / 2,
			});

			self.windingTubeHoldersGroup.add(engineRect);

			totalWidth += engineWidth;
		}

		var holderOffset = 11;
		var holderLeftX = -holderOffset;

		if(this.controlSide == 'left'){
			if(this.control == 'crank') holderLeftX -= crankElement.width;
			if(this.control == 'engine') holderLeftX -= engineWidth;
		}

		totalX += holderLeftX;
		totalWidth += 2 * holderOffset;

		var holderRightX = pipeInnerWidth + holderOffset;

		if(self.controlSide == 'right'){
			if(self.control == 'crank') holderRightX += crankElement.width;
			if(self.control == 'engine') holderRightX += engineWidth;
		}

		let imageObj = new Image();
		imageObj.crossOrigin = 'anonymous';
		imageObj.onload = function () {
			var node = new Konva.Image({
				width: holderElement.width,
				height: holderElement.height,
				image: imageObj,
				y: 0,
			});

			node.x(holderLeftX);

			self.windingTubeHoldersGroup.add(node);
			node.moveToBottom();

			let clone = node.clone({
				x: holderRightX,
				scaleX: -1,
			});

			self.windingTubeHoldersGroup.add(clone);
			clone.moveToBottom();
		};
		imageObj.src = this.settings.images[holderElement.image];

		this.totalWidth = totalWidth;
		this.tubeHelperRect.x(totalX);
		this.tubeHelperRect.width(totalWidth);

		this.updateTarpDimensions();
	}

	setWindingTubeColor(color){
		this.tubeRect.fill(color);
	}

	updatePipe(){
		let self = this;
		this.pipeGroup.destroyChildren();

		if(this.mountingType != 'guide'){
			var pipeHeight = 35;
			var pipeWidth = this.tarpWidth + 60;
			var pipeX = -30;
			var pipeY = this.tarpHeight - pipeHeight

			this.pipeGroup.x(pipeX);
			this.pipeGroup.y(pipeY);
			this.pipeGroup.width(pipeWidth);
			this.pipeGroup.moveToBottom();

			let pipeRect = new Konva.Rect({
				x: 0,
				y: 0,
				width: pipeWidth,
				height: pipeHeight,
				fill: '#ccc',
			});

			this.pipeGroup.add(pipeRect);

			let element = this.getExtrasElement('pipe_hook');
			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				var node = new Konva.Image({
					width: element.width,
					height: element.height,
					image: imageObj,
					y: pipeHeight - element.height,
					x: 5,
				});

				self.pipeGroup.add(node);
				node.moveToBottom();

				var clone = node.clone({
					x: pipeWidth - element.width - 5,
				});

				self.pipeGroup.add(clone);
				clone.moveToBottom();
			};
			imageObj.src = this.settings.images[element.image];
		}
	}

	setRailHolders(holders){
		this.railHolders = holders;
		this.updateRails();
	}

	updateRails(){
		this.railGroupLeft.destroyChildren();
		this.railGroupRight.destroyChildren();
		this.railGroupRight.scaleX(-1);

		if(this.mountingType == 'guide'){
			let self = this;
			let element = this.getExtrasElement('rail');
			let height = this.tarpHeight;
			let railOffsetFromTop = 100;
			let railHeight = height - railOffsetFromTop;

			this.railGroupLeft.x(element.offsetFromSide - (element.width-10));
			this.railGroupLeft.y(railOffsetFromTop);
			this.railGroupRight.x(this.tarpWidth + element.width - element.offsetFromSide - 10);
			this.railGroupRight.y(railOffsetFromTop);

			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				let scale = element.width / imageObj.width;
				let node = new Konva.Rect({
					x: 0,
					y: 0,
					width: element.width,
					height: railHeight,
					fillPatternImage: imageObj,
					fillPatternRepeat: 'repeat-y',
					fillPatternScaleY: scale,
					fillPatternScaleX: scale,
				});

				self.railGroupLeft.add(node);
				self.railGroupRight.add(node.clone());

				if(self.railHolders == 'corner' || self.railHolders == 'flat'){
					var holders = (self.railHolders == 'corner') ? 'wall' : 'ceiling';
					let group = new Konva.Group();
					let holderElement = self.getExtrasElement('rail_holder_'+holders);
					let sideLength = railHeight - 2 * holderElement.offsetFromSide;
					let startX = (self.railHolders == 'corner') ? -holderElement.height * 0.4 : -holderElement.height * 0.13;
					let startY = railOffsetFromTop;//holderElement.width + railOffsetFromTop;//railY - (holderElement.height - element.height) + 1;
					let space = 800;

					let elementsCount = Math.round(sideLength / (holderElement.width + space)) + 1;
					elementsCount = (elementsCount < 2) ? 2 : elementsCount;
					let elementsGap = (sideLength-holderElement.width) / (elementsCount-1);

					group.x(startX);
					group.y(startY);

					let imageObj = new Image();
					imageObj.crossOrigin = 'anonymous';
					imageObj.onload = function () {
						for(var i = 0; i < elementsCount; i++){
							var y = i * elementsGap;
							var node = new Konva.Image({
								width: holderElement.width,
								height: holderElement.height,
								image: imageObj,
								y: y,
								rotation: -90,
							});

							group.add(node);
						}

						self.railGroupLeft.add(group);
						self.railGroupRight.add(group.clone());
					};
					imageObj.src = self.settings.images[holderElement.image];

				}
			};
			imageObj.src = self.settings.images[element.image];
		}
	}

	addWindow(uid, width, height, offsetLeft, offsetBottom){
		if(width && height && offsetLeft && offsetBottom){
			this.deleteWindow(uid);
			let self = this;

			this.windowsData[uid] = {
				uid: uid,
				width: width,
				height: height,
				offsetLeft: offsetLeft,
				offsetBottom: offsetBottom,
			};

			let rect = new Konva.Rect({
				x: offsetLeft,
				y: self.tarpHeight - offsetBottom - height,
				width: width,
				height: height,
				fill: '#e4f8ff',
				id: uid,
				draggable: true, //TODO
				name: 'window collisionFill',
			});

			rect.on('dragmove', function (e) {
				let newBBox = this.getClientRect({relativeTo: self.tarpLayer});
				let windowData = {
					uid: uid,
					width: width,
					height: height,
					offsetLeft: newBBox.x,
					offsetBottom: self.tarpHeight - height - newBBox.y,
				};
				const event = new CustomEvent('configurator_window_moved', { detail: windowData});

				self.windowsData[uid] = windowData;
				window.dispatchEvent(event);

				self.checkAllCollisions();
			});

			rect.on('mouseenter', function () {
				self.stage.container().style.cursor = 'move';
			});
			rect.on('mouseleave', function () {
				self.stage.container().style.cursor = 'default';
			});

			this.windows.add(rect);
			this.checkAllCollisions();
		}
		else{
			this.deleteWindow(uid);
		}
	}

	updateWindows(){
		let self = this;
		for (const [uid,data] of Object.entries(this.windowsData)) {
			self.addWindow(uid, data.width, data.height, data.offsetLeft, data.offsetBottom);
		}
		this.checkAllCollisions();
	}

	deleteWindow(uid){
		let elems = this.stage.find('#'+uid);
		if(elems.length){
			elems[0].destroy();
		}

		delete this.windowsData[uid];

		this.checkAllCollisions();
	}

	/**
	 * Helpers
	 */

	getTarpHeightDiff(){
		return Math.abs(this.tarpHeightLeft - this.tarpHeightRight)
	}

	getTarpSlantLength(){
		let heightDiff = this.getTarpHeightDiff();
		return Math.sqrt( Math.pow(heightDiff,2) + Math.pow(this.tarpWidth,2) );
	}

	getTarpSlantY(x){
		let slantLength = this.getTarpSlantLength();
		let slantPartLength = (x / this.tarpWidth) * slantLength;
		let width = x;

		if(this.tarpHeightLeft < this.tarpHeightRight){
			slantPartLength = slantLength - slantPartLength;
			width = this.tarpWidth - x;
		}

		return Math.sqrt( Math.pow(slantPartLength,2) - Math.pow(width,2));
	}

	getExtrasElement(element){
		let extrasElements = {
			oval : {
				width : 37,
				height : 60,
				offsetFromSide : 5,
				type : 'side_image',
				image: 'eyelet_oval',
			},
			rotating_lock : {
				width : 37,
				height : 60,
				offsetFromSide : 5,
				type : 'side_image',
				image: 'eyelet_rotating_lock',
			},
			plastic_rotating_lock : {
				width : 42,
				height : 60,
				offsetFromSide : 3,
				type : 'side_image',
				image: 'plastic_rotating_lock',
			},
			oval_small : {
				width : 29,
				height : 39,
				offsetFromSide : 11,
				type : 'side_image',
				image: 'eyelet_oval_small',
			},
			rotating_lock_small : {
				width : 29,
				height : 39,
				offsetFromSide : 11,
				type : 'side_image',
				image: 'eyelet_rotating_lock_small',
			},
			rolling_gate_slider : {
				width : 80,
				height : 24,
				offsetFromSide : -25,
				type : 'side_image',
				image: 'rolling_gate_slider',
			},
			tube_holder : {
				width : 50,
				height : 80,
				offsetFromSide : 0,
				type : 'standalone',
				image: 'tube_holder',
			},
			crank : {
				width : 35,
				height : 120,
				offsetFromSide : 0,
				type : 'standalone',
				image: 'crank',
			},
			rail : {
				width : 45,
				offsetFromSide : -25,
				type : 'long_image',
				image: 'rail_pattern_rotated',
			},
			rail_holder_wall : {
				width : 60,
				height : 77,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'rail_holder_wall',
			},
			rail_holder_ceiling : {
				width : 60,
				height : 53,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'rail_holder_ceiling',
			},
			pipe_hook : {
				width : 17,
				height : 50,
				offsetFromSide : 0,
				type : 'standalone',
				image: 'pipe_hook',
			},
		}

		return extrasElements[element];
	}

	/**
	 * Dirt Lap
	 */

	addDirtLap(){
		this.dirtLap.remove();
		let dirtLapHeight = 200;
		let width = this.tarpWidth;
		let x = 0;
		let y = this.tarpHeight;
		let heightDiff = this.getTarpHeightDiff();

		let rect = new Konva.Line({
			points: [0,0, width,0, width,dirtLapHeight, 0,dirtLapHeight],
			closed: true,
			fillLinearGradientStartPoint: {
				x: width/2,
				y: dirtLapHeight/2,
			},
			fillLinearGradientEndPoint: {
				x: width/2,
				y: dirtLapHeight+300,
			},
			fillLinearGradientColorStops: [0, this.tarp.fill(), 1, 'black'],
		});

		let line = new Konva.Line({
			points: [0,0, width, 0],
			stroke: 'gray',
			strokeWidth: 2,
		});

		if(heightDiff && this.slant == 'bottom'){
			y = this.tarpHeight - heightDiff;

			if(this.tarpHeightLeft < this.tarpHeightRight){
				var rY = heightDiff;

				line.points([0,0, width,rY]);
				rect.points([0,0, width,rY, width,rY+dirtLapHeight, 0,dirtLapHeight])
			}
			else{
				var lY = heightDiff;

				line.points([0,lY, width,0]);
				rect.points([0,lY, width,0, width,dirtLapHeight, 0,lY+dirtLapHeight])
			}
		}

		this.dirtLap = new Konva.Group({
			x: x,
			y: y,
			width: width,
			height: dirtLapHeight,
		});

		this.dirtLap.add(rect);
		this.dirtLap.add(line);
		this.tarpLayer.add(this.dirtLap);
		this.hasDirtLap = true;

		this.updateTarpDimensions();
	}

	updateDirtLap(){
		if(this.hasDirtLap){
			this.addDirtLap();
		}
	}

	removeDirtLap(){
		this.hasDirtLap = false;
		this.dirtLap.remove();

		this.updateTarpDimensions();
	}

	/**
	 * Hit Boxes
	 */
	updateHitBoxes(){
		let self = this;
		this.hitBoxesGroup.destroy();
		this.hitBoxesGroup = new Konva.Group();
		let heightDiff = this.getTarpHeightDiff();
		let hitBoxWidth = 99;
		let hitBoxDiff = this.getTarpSlantY(hitBoxWidth);

		for(var i = 0; i < Math.ceil(this.tarpWidth / hitBoxWidth); i++){
			let y = 0;

			if(heightDiff){

				if(self.tarpHeightLeft > self.tarpHeightRight){
					y = i * hitBoxDiff;
				}
				else{
					y = heightDiff - i * (heightDiff - hitBoxDiff);
				}
			}

			let hitBoxTop = new Konva.Rect({
				x: i * hitBoxWidth,
				y: y,
				width: hitBoxWidth,
				height: hitBoxWidth,
				fill: 'transparent',
				name: 'hitBoxTop',
			});
			self.hitBoxesGroup.add(hitBoxTop);
		}

		let hitBoxLeft = new Konva.Rect({
			x: 0,
			y: 0,
			width: hitBoxWidth,
			height: this.tarpHeight,
			fill: 'transparent',
			name: 'hitBoxLeft',
		});

		let hitBoxRight = new Konva.Rect({
			x: this.tarpWidth - hitBoxWidth,
			y: 0,
			width: hitBoxWidth,
			height: this.tarpHeight,
			fill: 'transparent',
			name: 'hitBoxRight',
		});

		let hitBoxBottom = new Konva.Rect({
			x: 0,
			y: this.tarpHeight - hitBoxWidth,
			width: this.tarpWidth,
			height: hitBoxWidth,
			fill: 'transparent',
			name: 'hitBoxBottom',
		});


		this.hitBoxesGroup.add(hitBoxLeft);
		this.hitBoxesGroup.add(hitBoxRight);
		this.hitBoxesGroup.add(hitBoxBottom);

		this.tarpLayer.add(this.hitBoxesGroup);
	}

	/**
	 * Collisions
	 */

	checkAllCollisions(){
		this.checkWindowsCollisions();

		this.triggerErrorsUpdateEvent();
	}

	checkWindowsCollisions(){
		let self = this;
		self.removeError('windows');
		this.windows.children.forEach(function(el){
			let res = self.checkCollision(el);
			if(res){
				el.fill('#ff5761');
				self.addError('windows');
			}
			else{
				el.fill('#e4f8ff');
			}
		});
	}

	checkCollision(target, excludeName = ''){
		let self = this;
		let res = false;
		let elementsToCheck = [];

		elementsToCheck = elementsToCheck.concat(this.hitBoxesGroup.children);

		elementsToCheck.forEach(function(el){
			if(el !== target && !(excludeName !== '' && el.name().includes(excludeName)) ){
				if(self.haveIntersection(target,el)){
					res = true;
				}
			}
		});

		if(!res){
			res = !self.haveIntersection(target,this.tarp);
		}

		return res;
	}

	haveIntersection(shape1, shape2) {
		let r1 = shape1.getClientRect({relativeTo: this.tarpLayer});
		let r2 = shape2.getClientRect({relativeTo: this.tarpLayer});

		return !(
			r2.x > r1.x + r1.width ||
			r2.x + r2.width < r1.x ||
			r2.y > r1.y + r1.height ||
			r2.y + r2.height < r1.y
		);
    }

	/**
	 * Dimensions
	 */
	updateTarpDimensions(){
		this.tarpDimensions.destroyChildren();
		let tLRect = this.tarp.getClientRect({skipShadow: true, relativeTo: this.stage});
		let tubeRect = this.tubeHelperRect.getClientRect({skipShadow: true, relativeTo: this.stage});

		let dimHeightLeft = this.getDimensionsLines(tLRect.height, ('B: '+this.tarpHeight/10)+'cm', {
			x: (this.mountingType == 'guide') ?  tLRect.x - 60 : tLRect.x - 40,
			y: tLRect.y,
		}, 'height_left', false, 1);
		let dimHeightRight = this.getDimensionsLines(tLRect.height + tubeRect.height, ((this.tarpHeight + 80)/10)+'cm', {
			x: (this.mountingType == 'guide') ? tLRect.x + tLRect.width + 50 : tLRect.x + tLRect.width + 30,
			y: tubeRect.y,
		}, 'height_right', false);
		let dimWidth = this.getDimensionsLines(tLRect.width, ('A: '+this.tarpWidth/10)+'cm', {
			x: tLRect.x,
			y: tLRect.y + tLRect.height + 20,
		}, 'width');

		if(this.hasDirtLap){
			dimWidth.y( dimWidth.y() + this.dirtLap.getClientRect().height );
		}

		var totalWidth = this.tarpWidth;

		if(this.mountingType == 'guide') totalWidth += 90;
		else totalWidth += 10;

		if(this.control == 'crank') totalWidth += 90;
		else totalWidth += 72;

		let dimWidthTotal = this.getDimensionsLines(tubeRect.width, totalWidth/10+'cm', {
			x: tubeRect.x,
			y: tubeRect.y - 30,
		}, 'width', true, 1);

		this.tarpDimensions.add(dimHeightLeft);
		this.tarpDimensions.add(dimWidth);
		this.tarpDimensions.add(dimHeightRight);
		this.tarpDimensions.add(dimWidthTotal);
	}

	getDimensionsLines(length, textLabel, newAtts = {}, clickName = '', horizontally = true, textPos = 2){
		let self = this;
		let linesGroup = new Konva.Group();
		let marker1 = new Konva.Line({
			points: [0,0,0,12],
			stroke: 'gray',
			strokeWidth: 1,
			lineCap: 'round',
			lineJoin: 'round',
		});
		let lineMiddle = new Konva.Line({
			points: [0,6,length,6],
			stroke: 'gray',
			strokeWidth: 1,
			lineCap: 'round',
			lineJoin: 'round',
		});
		let marker2 = new Konva.Line({
			points: [length,0,length,12],
			stroke: 'gray',
			strokeWidth: 1,
			lineCap: 'round',
			lineJoin: 'round',
		});
		let text = new Konva.Text({
			x: length / 2,
			y: 12,
			text: textLabel,
			fontSize: 16,
			fill: 'black',
		});

		if(horizontally){
			text.offsetX(text.width() / 2);
			if(textPos == 1){
				text.y(-16)
			}
		}
		else{
			marker1.points([0,0,12,0]);
			lineMiddle.points([6,0,6,length]);
			marker2.points([0,length,12,length]);
			text.y(length/2);

			if(textPos === 1){
				text.x(-1 * text.width());
			}
			else{
				text.x(12);
			}
			text.offsetY(text.height() / 2);
		}

		linesGroup.add(marker1);
		linesGroup.add(lineMiddle);
		linesGroup.add(marker2);
		linesGroup.add(text);

		if(clickName.length){
			text.on('mouseenter', function () {
				self.stage.container().style.cursor = 'pointer';
			});
			text.on('mouseleave', function () {
				self.stage.container().style.cursor = 'default';
			});
			text.on('click', function () {
				const event = new CustomEvent('configurator_dimension_click', { detail: {
					name: clickName,
				}});
				window.dispatchEvent(event);
			});
		}

		let copy = linesGroup.clone(newAtts);
		linesGroup.destroy();
		return copy;
	}

	/**
	 * Errors
	 */

	addError(key){
		this.removeError(key);
		this.errors.push(key);
	}

	removeError(key){
		const index = this.errors.indexOf(key);
		if (index > -1){
			this.errors.splice(index, 1);
		}
	}

	getErrors(){
		return this.errors;
	}

	triggerErrorsUpdateEvent(){
		let self = this;
		const event = new CustomEvent('configurator_errors_update', { detail: {
			errors: self.getErrors(),
		}});
		window.dispatchEvent(event);
	}

	/**
	 * Stage
	 */

	allowStageZoom(){

		/**
		 * Wheel zoom
		 */
		var scaleBy = 1.25;
		this.stage.on('wheel', (e) => {
			// stop default scrolling
			e.evt.preventDefault();

			var oldScale = this.stage.scaleX();
			var pointer = this.stage.getPointerPosition();

			var mousePointTo = {
				x: (pointer.x - this.stage.x()) / oldScale,
				y: (pointer.y - this.stage.y()) / oldScale,
			};

			// how to scale? Zoom in? Or zoom out?
			let direction = e.evt.deltaY > 0 ? -1 : 1;

			var newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

			this.stage.scale({ x: newScale, y: newScale });

			var newPos = {
				x: pointer.x - mousePointTo.x * newScale,
				y: pointer.y - mousePointTo.y * newScale,
			};
			this.stage.position(newPos);
		});

		/**
		 * Mobile pinch zoom
		 */

		this.stage.on('touchmove', (e) => {
			e.evt.preventDefault();
			var touch1 = e.evt.touches[0];
			var touch2 = e.evt.touches[1];

			if (touch1 && touch2) {
				this.stage.draggable(false);

				var p1 = {
					x: touch1.clientX,
					y: touch1.clientY,
				};
				var p2 = {
					x: touch2.clientX,
					y: touch2.clientY,
				};

				if (!this.mobileLastCenter) {
					this.mobileLastCenter = this.getCenter(p1, p2);
					return;
				}
				var newCenter = this.getCenter(p1, p2);

				var dist = this.getDistance(p1, p2);

				if (!this.mobileLastDist) {
					this.mobileLastDist = dist;
				}

				// local coordinates of center point
				var pointTo = {
					x: (newCenter.x - this.stage.x()) / this.stage.scaleX(),
					y: (newCenter.y - this.stage.y()) / this.stage.scaleX(),
				};

				var scale = this.stage.scaleX() * (dist / this.mobileLastDist);

				this.stage.scaleX(scale);
				this.stage.scaleY(scale);

				// calculate new position of the stage
				var dx = newCenter.x - this.mobileLastCenter.x;
				var dy = newCenter.y - this.mobileLastCenter.y;

				var newPos = {
					x: newCenter.x - pointTo.x * scale + dx,
					y: newCenter.y - pointTo.y * scale + dy,
				};


				this.stage.position(newPos);

				this.mobileLastDist = dist;
				this.mobileLastCenter = newCenter;
			}
		});

		this.stage.on('touchend', (e) => {
			this.mobileLastDist = 0;
			this.mobileLastCenter = null;
			this.stage.draggable(true);
		});
	}

	getCenter(p1, p2) {
		return {
			x: (p1.x + p2.x) / 2,
			y: (p1.y + p2.y) / 2,
		};
    }

	getDistance(p1, p2) {
		return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }
}

export default ConfiguratorRollingGate;



// WEBPACK FOOTER //
// ./scripts/util/ConfiguratorRollingGate.js